import React, { PureComponent } from 'react';

import DateHelper from 'helpers/Date';
import PropTypes from 'prop-types';

import PlayerReportStatistic from './PlayerReportStatistic';

export default class PlayerReportStatistics extends PureComponent {
  static propTypes = {
    statistics: PropTypes.object
  };

  static defaultProps = {
    statistics: {}
  };

  render() {
    const { totalViews = 0, averageViewTime = 0 } = this.props.statistics;

    return (
      <div className="player__report__statistics">
        <PlayerReportStatistic
          label="embed_statistics_modal.total_views"
          value={totalViews.toLocaleString()}
        />
        <PlayerReportStatistic
          label="embed_statistics_modal.average_view_time"
          value={DateHelper.secondsToHms(averageViewTime)}
        />
      </div>
    );
  }
}
